/* eslint-disable @typescript-eslint/no-unused-vars */
import { message } from 'antd';
import React from 'react';
import { useMutation } from 'react-query';
import { Typography } from 'tfc-components';

import Button from 'components/atoms/Button';
import MicrosoftLogin from 'components/organisms/LoginSocials/MicrosoftLogin';
import { getPKCESocialDataService } from 'services/auth';
import { setLocalStorage } from 'services/common/storage';
import { LOCAL_STORAGE, ROUTE_PATHS, SOCIAL_LOGIN_HOST } from 'utils/constants';

const LoginSocials: React.FC = () => {
  /* Queries */
  const { mutate: getPCKESocial, isLoading: isLoadingPCKESocial } = useMutation(
    'getPCKESocialMutate',
    getPKCESocialDataService,
    {
      onSuccess(data, variables) {
        const state = Math.random().toString(36).slice(2);
        setLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_UUID, data?.uuid);
        setLocalStorage(LOCAL_STORAGE.SOCIAL_PKCE_STATE, state);
        setLocalStorage(LOCAL_STORAGE.SOCIAL_CODE_CHALLENGE, data.codeChallenge);
        const params = {
          response_type: data.responseType,
          client_id: data.clientId,
          code_challenge: data.codeChallenge,
          code_challenge_method: data.codeChallengeMethod,
          state,
        };

        const googleParams = {
          ...params,
          redirect_uri: `${window.location.origin}${ROUTE_PATHS.LOGIN_GOOGLE}`,
          scope: `${data.scopes.join(' ')}`,
          prompt: 'select_account',
          include_granted_scopes: 'true',
        };

        const microsoftParams = {
          ...params,
          redirect_uri: `${window.location.origin}${ROUTE_PATHS.LOGIN_MICROSOFT}`,
          scope: `${data.scopes.join(' ')}`,
        };

        switch (variables) {
          case 'google':
            window.location.replace(`${SOCIAL_LOGIN_HOST.GOOGLE}?${new URLSearchParams(googleParams).toString()}`);
            break;
          case 'microsoft':
            window.location.replace(
              `${SOCIAL_LOGIN_HOST.MICROSOFT}?${new URLSearchParams(microsoftParams).toString()}`
            );
            break;
          default:
            break;
        }
      },
      onError(error) {
        message.error('Login failed !');
      },
    }
  );

  /* Functions */
  const loginWithGoogle = async () => {
    getPCKESocial('google');
  };

  return (
    <div className="o-loginSocials">
      <div className="o-loginSocials_google">
        <Button
          type="button"
          icon={{ align: 'left', name: 'global', size: '24' }}
          onClick={loginWithGoogle}
          disabled={isLoadingPCKESocial}
        >
          <Typography.Text fontweight="600" extendClasses="o-loginSocials_google-text">
            Continue with Google
          </Typography.Text>
        </Button>
      </div>

      <div className="o-loginSocials_google">
        <MicrosoftLogin />
      </div>
    </div>
  );
};

export default React.memo(LoginSocials);
